<section [ngClass]="dynamicClass">
  <app-breadcrumb *ngIf="breadcrumbData" [data]="breadcrumbData"></app-breadcrumb>
  <section class="pb-container">
    <div class="pb-article pb-article-piraeus pb-mx-auto !pb-space-y-9">
      <h1 class="pb-text-color-brand pb-text-d-xl-m lg:pb-text-d-xl">{{rendering.fields?.result?.CardOffer?.Title}}</h1>
      <img *ngIf="image.src" offset="100" [defaultImage]="'images/default-image.png' | asset" [lazyLoad]="image.src" alt="{{image.alt}}" class="pb-h-full pb-w-full">
      <div [innerHTML]="rendering.fields?.result?.CardOffer?.Content | TrustHtml"></div>
    </div>
    <div app-documents class="pb-max-w-[52.5rem] pb-mt-9 pb-mx-auto" [title]="rendering.fields?.result?.CardOffer?.DocumentTitle" [subtitle]="rendering.fields?.result?.CardOffer?.DocumentSubtitle" [documents]="rendering.fields?.result?.CardOffer?.Documents"></div>
  </section>
</section>